import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Wave 15 Step 9 (Founder 2 Oct 2026) · old /app/saved header route is gone;
 * saved events now live inside the member's own profile. Any inbound deep
 * link gets redirected to /app/me?view=saved so nothing 404s.
 */
export default function SavedRedirect() {
  const nav = useNavigate();
  useEffect(() => {
    nav("/app/me?view=saved", { replace: true });
  }, [nav]);
  return null;
}
